import global from './global.js';
import splitter from './splitter/index.js';
import stepper from './stepper/index.js';
import table from "./tables/index.js";

export default {
    global,
    stepper,
    splitter,
    ...table
}
